// Swipe handler for product card images on mobile devices
(function() {
  'use strict';

  const WRAPPER_SELECTOR = '.ProductItem__ImageWrapper--withAlternateImage[data-swipeable="true"]';
  const MIN_SWIPE_DISTANCE = 50;

  let swipeStart = null;

  function setSwiped(wrapper, swiped) {
    wrapper.classList.toggle('is-swiped', swiped);

    wrapper.querySelectorAll('.ProductSwipe__Dot').forEach((dot, index) => {
      dot.classList.toggle('is-active', index === (swiped ? 1 : 0));
    });
  }

  // Listeners live on the document so cards loaded later (sub-collection links, section reloads) work too
  document.addEventListener('touchstart', (e) => {
    const wrapper = e.target.closest(WRAPPER_SELECTOR);

    // Carousels use horizontal swipes to scroll, so leave their cards alone
    if (!wrapper || wrapper.closest('.Carousel__Cell') || e.touches.length > 1) {
      swipeStart = null;
      return;
    }

    swipeStart = { wrapper: wrapper, x: e.touches[0].clientX, y: e.touches[0].clientY };
  }, { passive: true });

  document.addEventListener('touchend', (e) => {
    if (!swipeStart) return;

    const { wrapper, x, y } = swipeStart;
    const distanceX = e.changedTouches[0].clientX - x;
    const distanceY = e.changedTouches[0].clientY - y;
    swipeStart = null;

    // Ignore taps and mostly vertical page scrolls
    if (Math.abs(distanceX) < MIN_SWIPE_DISTANCE || Math.abs(distanceX) < Math.abs(distanceY)) return;

    // Swipe left shows the alternate image, swipe right goes back to the primary one
    setSwiped(wrapper, distanceX < 0);
  }, { passive: true });

  document.addEventListener('touchcancel', () => {
    swipeStart = null;
  }, { passive: true });

  // Tapping the dots switches the image instead of opening the product.
  // Capture phase so it runs before the theme's page transition link handler.
  document.addEventListener('click', (e) => {
    const indicators = e.target.closest('.ProductSwipe__Indicators');
    const wrapper = indicators && indicators.closest(WRAPPER_SELECTOR);
    if (!wrapper) return;

    e.preventDefault();
    e.stopPropagation();

    const dot = e.target.closest('.ProductSwipe__Dot');
    const dots = Array.from(indicators.querySelectorAll('.ProductSwipe__Dot'));
    setSwiped(wrapper, dot ? dots.indexOf(dot) === 1 : !wrapper.classList.contains('is-swiped'));
  }, true);

  // Picking a colour swaps the primary image, so bring it back into view
  function resetCard(target) {
    const card = target.closest('.ProductItem');
    const wrapper = card && card.querySelector(WRAPPER_SELECTOR);
    if (wrapper) setSwiped(wrapper, false);
  }

  document.addEventListener('change', (e) => {
    if (e.target.matches('.ColorSwatch__Radio')) resetCard(e.target);
  });

  document.addEventListener('click', (e) => {
    const swatch = e.target.closest('.ColorSwatch--selectable');
    if (swatch) resetCard(swatch);
  });
})();
